import axios from 'axios'
import { ApiResponse } from '../models/Base'
import { SeasonDto, SeasonRequestDto } from '../models/dto/Season'


const API_URL = process.env.REACT_APP_API_URL
const SEASON_URL = `${API_URL}/seasons`

export function GetSeasons(){
    return axios.get<ApiResponse<SeasonDto[]>>(`${SEASON_URL}`)
}

export function GetLastSeason() {
    return axios.post<ApiResponse<SeasonDto>>(`${SEASON_URL}/lasts`)
}

export function GetActiveSeasons(){
    return axios.get<ApiResponse<SeasonDto[]>>(`${SEASON_URL}/actives`)
}

 
export function GetById(payload: number) {
    return axios.get<ApiResponse<SeasonDto>>(`${SEASON_URL}/${payload}`)
}

export function Create(payload: SeasonRequestDto) {
    return axios.post(`${SEASON_URL}`, payload)
}

export function Update(id: number, payload: SeasonRequestDto) {
    return axios.put(`${SEASON_URL}/${id}`, payload)
}

export function Delete(id: number) {
    return axios.delete(`${SEASON_URL}/${id}`)
}
